// function initFlagSlider() {
//   if (window.innerWidth >= 750) return;

//   let isInitialLoad = true;

//   const flag_tabs = document.querySelectorAll(".Index_flag_slider_product_block");
//   const flag_contents = document.querySelectorAll(".Index_flag_slider_tab_media");

//   flag_tabs.forEach(flag_tab => {
//     flag_tab.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       flag_tabs.forEach(t => t.classList.remove("active"));
//       this.classList.add("active");

//       if (!isInitialLoad) {
//         this.scrollIntoView({
//           behavior: "smooth",
//           inline: "center",
//           block: "nearest"
//         });
//       }

//       const data_flag_tab = this.dataset.flagTab;

//       flag_contents.forEach(flag_content => {
//         if (data_flag_tab == flag_content.dataset.flagContent) {
//           flag_content.classList.add("show");
//         } else {
//           flag_content.classList.remove("show");
//         }
//       });
//     });
//   });

//   const firstTab = document.querySelector(".Index_flag_slider_product_block:first-child");
//   if (firstTab) firstTab.click();

//   isInitialLoad = false;
// }

// initFlagSlider();
// window.addEventListener("resize", initFlagSlider);

function initFlagSlider() {
  if (window.innerWidth >= 750) return;

  let isInitialLoad = true;

  const flag_tabs = document.querySelectorAll(".Index_flag_slider_product_block");
  const flag_contents = document.querySelectorAll(".Index_flag_slider_tab_media");

  function setActiveFlagTab(activeTab) {
    if (!activeTab) return;

    flag_tabs.forEach(t => t.classList.remove("active"));
    activeTab.classList.add("active");

    const data_flag_tab = activeTab.dataset.flagTab;

    flag_contents.forEach(flag_content => {
      if (data_flag_tab == flag_content.dataset.flagContent) {
        flag_content.classList.add("show");
      } else {
        flag_content.classList.remove("show");
      }
    });
  }

  flag_tabs.forEach(flag_tab => {
    if (flag_tab.dataset.flagInitialized === "true") return;

    flag_tab.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      setActiveFlagTab(this);

      if (!isInitialLoad) {
        this.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    });

    flag_tab.dataset.flagInitialized = "true";
  });

  const firstTab = document.querySelector(".Index_flag_slider_product_block:first-child");
  if (firstTab) setActiveFlagTab(firstTab);

  isInitialLoad = false;
}

initFlagSlider();

let resizeTimer;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initFlagSlider, 300);
});
